import {
    useTooltipContentStyles,
} from 'app/shared-components/Tooltip'

import useStyles from './AllowDuplicationTooltipContent.styles'

const AllowDuplicationTooltipContent = () => {
    const {
        classes, cx,
    } = useStyles()
    const {
        classes: sharedTooltipClasses,
    } = useTooltipContentStyles()

    return (
        <div>
            <p className={sharedTooltipClasses.header}>
                Lanes with the same Origin, Destination,
                and Lane Fees will be filtered, only one representative lane
                will be displayed.
            </p>
            <p className={cx(sharedTooltipClasses.paragraph, classes.paragraph)}>
                To view all lanes in the selected Lane Group,
                please check the “Allow Duplication” box.
            </p>
        </div>
    )
}

export default AllowDuplicationTooltipContent
